const products = [
    {
        id: 9,
        name: "तेजा मिर्च पाउडर",
        category: "पिसे मसाले",
        desc: "तेज तीखापन और रंग।",
        variants: [
            {
                weight: "100 ग्राम",
                price: 30,
                image: "/images/product/teja-mirchi.jpg",
            },
            {
                weight: "200 ग्राम",
                price: 80,
                image: "/images/product/teja-mirchi.jpg",
            },
            {
                weight: "500 ग्राम",
                price: 160,
                image: "/images/product/teja-mirchi.jpg",
            },
        ],
    },
    {
        id: 10,
        name: "हल्दी पाउडर",
        category: "पिसे मसाले",
        desc: "शुद्ध हल्दी, प्राकृतिक रंग।",
        variants: [
            {
                weight: "100 ग्राम",
                price: 30,
                image: "/images/product/haldi-powder.jpg",
            },
            {
                weight: "200 ग्राम",
                price: 60,
                image: "/images/product/haldi-powder.jpg",
            },
            {
                weight: "500 ग्राम",
                price: 180,
                image: "/images/product/haldi-powder.jpg",
            },
        ],
    },
    {
        id: 11,
        name: "धनिया पाउडर",
        category: "पिसे मसाले",
        desc: "खुशबूदार धनिया पाउडर।",
        variants: [
            {
                weight: "100 ग्राम",
                price: 20,
                image: "/images/product/daniya.jpg",
            },
            {
                weight: "200 ग्राम",
                price: 30,
                image: "/images/product/daniya.jpg",
            },
            {
                weight: "500 ग्राम",
                price: 160,
                image: "/images/product/daniya.jpg",
            },
        ],
    },
    {
        id: 1,
        name: "जीरावन पोहा मसाला",
        category: "मिक्स मसाले",
        desc: "इंदौरी स्वाद से भरपूर जीरावन पोहा मसाला।",
        variants: [
            {
                weight: "100 ग्राम",
                price: 45,
                image: "/images/product/jiravan.jpg",
            },
            {
                weight: "500 ग्राम",
                price: 160,
                image: "/images/product/jiravan.jpg",
            },
        ],
    },
    {
        id: 2,
        name: "चाट मसाला",
        category: "मिक्स मसाले",
        desc: "हर चाट का स्वाद बढ़ाने वाला खास मसाला।",
        variants: [
            {
                weight: "100 ग्राम",
                price: 110,
                image: "/images/product/chaat.jpg",
            },
        ],
    },
    {
        id: 3,
        name: "छोले मसाला",
        category: "मिक्स मसाले",
        desc: "पंजाबी स्वाद से भरपूर छोले मसाला।",
        variants: [
            {
                weight: "100 ग्राम",
                price: 90,
                image: "/images/product/chole.jpg",
            },
        ],
    },
    {
        id: 4,
        name: "कसूरी मेथी",
        category: "पिसे मसाले",
        desc: "खुशबूदार कसूरी मेथी।",
        variants: [
            {
                weight: "25 ग्राम",
                price: 40,
                image: "/images/product/kasturi-maithi.jpg",
            },
        ],
    },
    {
        id: 5,
        name: "सांभर मसाला",
        category: "मिक्स मसाले",
        desc: "दक्षिण भारतीय स्वाद के लिए खास।",
        variants: [
            {
                weight: "50 ग्राम",
                price: 45,
                image: "/images/product/sambhar.jpg",
            },
        ],
    },
    {
        id: 6,
        name: "खड़ा पीसा मसाला",
        category: "मिक्स मसाले",
        desc: "खड़े मसालों से तैयार पारंपरिक मसाला।",
        variants: [
            {
                weight: "100 ग्राम",
                price: 120,
                image: "/images/product/garam.jpg",
            },
            {
                weight: "500 ग्राम",
                price: 600,
                image: "/images/product/garam.jpg",
            },
        ],
    },
    {
        id: 7,
        name: "कश्मीरी मिर्च पाउडर",
        category: "पिसे मसाले",
        desc: "तेज रंग और हल्का तीखापन।",
        variants: [
            {
                weight: "100 ग्राम",
                price: 110,
                image: "/images/product/kashmiri-mirchi.jpg",
            },
        ],
    },
    {
        id: 8,
        name: "किचन किंग मसाला",
        category: "मिक्स मसाले",
        desc: "हर सब्ज़ी का स्वाद बढ़ाए।",
        variants: [
            {
                weight: "50 ग्राम",
                price: 50,
                image: "/images/product/kitchen-king.jpg",
            },
        ],
    },

];

export default products;
